"use client";

import { useEffect } from "react";

export default function CustomCursor() {
  useEffect(() => {
    const cursorInner = document.querySelector(".cursor-inner") as HTMLElement;
    const cursorOuter = document.querySelector(".cursor-outer") as HTMLElement;

    if (!cursorInner || !cursorOuter) return;

    let mouseX = 0, mouseY = 0;
    let isHovering = false;

    const onMouseMove = (e:any) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      if (!isHovering) {
        cursorOuter.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
      }
      cursorInner.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
    };

    const onMouseEnter = () => {
      cursorInner.classList.add("cursor-hover");
      cursorOuter.classList.add("cursor-hover");
    };

    const onMouseLeave = () => {
      cursorInner.classList.remove("cursor-hover");
      cursorOuter.classList.remove("cursor-hover");
    };

    document.body.addEventListener("mousemove", onMouseMove);

    const hoverTargets = document.querySelectorAll("a, .cursor-pointer");
    hoverTargets.forEach((el) => {
      el.addEventListener("mouseenter", onMouseEnter);
      el.addEventListener("mouseleave", onMouseLeave);
    });

    // Show cursors
    cursorInner.style.visibility = "visible";
    cursorOuter.style.visibility = "visible";

    // Cleanup on unmount
    return () => {
      document.body.removeEventListener("mousemove", onMouseMove);
      hoverTargets.forEach((el) => {
        el.removeEventListener("mouseenter", onMouseEnter);
        el.removeEventListener("mouseleave", onMouseLeave);
      });
    };
  }, []);

  return (
    <>
     <div className="mouse-cursor cursor-outer"></div>
    <div className="mouse-cursor cursor-inner"></div>
    </>
  );
}
